import { useMemo } from 'react';
import {
  intCellFunc,
  intCurrencyCellFunc,
  intCurrencyFormatter,
  intFormatter,
} from 'src/components/molecules/DataTable/cellFuncs';
import {
  currencyValueTickFormatter,
  ValueTickFormatter,
} from '../utils/TickFormatters';
import { useCurrency } from './useCurrency';
import { useKpiUnit } from './useKpiUnit';

// Depending on if the kpi unit is euro (monetary) or not, we want to format
// effects differently; monetary values carry the customer's currency symbol.
// Memoized so consumers get a stable function reference across renders.

export const useChartEffectTickFormatter = () => {
  const { unit } = useKpiUnit();
  const { code } = useCurrency();

  return useMemo(
    () =>
      unit === 'euro' ? currencyValueTickFormatter(code) : ValueTickFormatter,
    [unit, code],
  );
};

export const useTableEffectCellFunc = () => {
  const { unit } = useKpiUnit();
  const { code } = useCurrency();

  return useMemo(
    () => (unit === 'euro' ? intCurrencyCellFunc(code) : intCellFunc),
    [unit, code],
  );
};

export const useTableEffectFormatter = () => {
  const { unit } = useKpiUnit();
  const { code } = useCurrency();

  return useMemo(
    () => (unit === 'euro' ? intCurrencyFormatter(code) : intFormatter),
    [unit, code],
  );
};
